import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=ad608cbe&"
import script from "./Frequency.js?vue&type=script&lang=js&"
export * from "./Frequency.js?vue&type=script&lang=js&"
import style0 from "./Frequency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports